import {ClientFunction} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/ClientFunction';
import {IVisualStreamId} from '@mintdata-wsp/common/state/ui/visualDesigner/visualData/VisualStreamIds';

export enum MeshTypeaheadItemKind
{
    FlowPort,
    ClientFunction,
    CustomAction,
}

export type TypeaheadItemCustomAction = () => void;

export class MeshTypeaheadItem<T>
{
    private constructor(public readonly kind:MeshTypeaheadItemKind,
                        public readonly title:string,
                        public readonly tip:string,
                        public readonly pillText:string,
                        public readonly datum:T)
    {
    }

    toFormulaDisplayString():string
    {
        const kind = this.kind;

        if( kind === MeshTypeaheadItemKind.ClientFunction )
        {
            const clientFunction:ClientFunction = this.datum as any;
            return clientFunction.getQualifiedName();
        }
        else if( kind === MeshTypeaheadItemKind.FlowPort )
        {
            const titleNoSpaces = this.title.replace(new RegExp(' ', 'g'), '');
            return `flow.${titleNoSpaces}()`;
        }
    }

    public static forFlowPort(title:string, visualStreamId:IVisualStreamId):MeshTypeaheadItem<IVisualStreamId>
    {
        return new MeshTypeaheadItem<IVisualStreamId>(MeshTypeaheadItemKind.FlowPort, title, null, 'flow', visualStreamId);
    }

    public static forClientFunction(cf:ClientFunction):MeshTypeaheadItem<ClientFunction>
    {
        return new MeshTypeaheadItem<ClientFunction>(MeshTypeaheadItemKind.ClientFunction, cf.getQualifiedName(), cf.tip, cf.namespace, cf);
    }

    public static forCustomAction(title:string, tip:string, pillText:string, datum:TypeaheadItemCustomAction):MeshTypeaheadItem<TypeaheadItemCustomAction>
    {
        return new MeshTypeaheadItem<TypeaheadItemCustomAction>(MeshTypeaheadItemKind.CustomAction, title, tip, pillText, datum);
    }
}
